import { HaNRoomsMap } from "src/components/organisms/hereAndNow/HaNRoomsMap/HaNRoomsMap";
import { HaNWorkspacesMap } from "src/components/organisms/hereAndNow/HaNWorkspacesMap/HaNWorkspacesMap";
import { isArea, isMeetingRoom } from "src/components/organisms/hereAndNow/helpers";
import { HereAndNowMapsProps } from "./types";
import { getIsWorkspacesOnHereAndNowEnabled, getMeetingRoomRequestState, useAppSelector } from "@lib/store";
import { Loader } from "@atoms";
import { Div } from "@quarks";
import { HaNExploreMap } from "./HaNExploreMap";
import { useActiveMeetingRoomRequest } from "src/components/pages/HereAndNow/Context/hooks/useActiveMeetingRoomRequest";
import { useHereAndNow } from "src/components/pages/HereAndNow/Context/HereAndNowContext";

export const HaNMaps = ({
  floorId,
  buildingId,
  onObjectClick,
  viewportRestrictions,
  selectedObject,
  hoverObjectId,
  exploreState,
  onOutsideClick,
}: HereAndNowMapsProps) => {
  const { currentRoomDateTimes, filterData, tab } = useHereAndNow();
  const request = useActiveMeetingRoomRequest({
    buildingId,
    selectedFloorId: floorId,
  });

  const isWorkspacesOnHereAndNowEnabled = useAppSelector(getIsWorkspacesOnHereAndNowEnabled);
  const meetingRoomLoadingStatus = useAppSelector(
    state => getMeetingRoomRequestState(state, request)?.selectedFloorLoadingStatus,
  );
  const loadingMeetingRooms = meetingRoomLoadingStatus === "loading" || meetingRoomLoadingStatus === undefined;

  const rooms = filterData.rooms.filteredData;
  const workspaces = filterData.workspaces.filteredData;

  if (loadingMeetingRooms && tab !== "explore") {
    return (
      <Div>
        <Loader />
      </Div>
    );
  }

  if (
    (tab === "rooms" || (!isWorkspacesOnHereAndNowEnabled && !tab)) &&
    (selectedObject === null || isMeetingRoom(selectedObject))
  ) {
    return (
      <HaNRoomsMap
        floorId={floorId}
        buildingId={buildingId}
        onRoomClick={onObjectClick}
        viewportRestrictions={viewportRestrictions}
        selectedRoom={selectedObject && selectedObject.floorId === floorId ? selectedObject : null}
        onOutsideClick={onOutsideClick}
        hoverRoom={rooms!.find(room => room.id === hoverObjectId) || null}
      />
    );
  }

  if (tab === "workspaces" && (selectedObject === null || isArea(selectedObject))) {
    return (
      <HaNWorkspacesMap
        floorId={floorId}
        buildingId={buildingId}
        hoverArea={workspaces.find(area => area.id === hoverObjectId) || null}
        onAreaClick={onObjectClick}
        selectedArea={selectedObject && selectedObject.floorId === floorId ? selectedObject : null}
        onOutsideClick={onOutsideClick}
        viewportRestrictions={viewportRestrictions}
      />
    );
  }

  if (tab === "explore") {
    return (
      <HaNExploreMap
        exploreState={exploreState}
        viewportRestrictions={viewportRestrictions}
        onOutsideClick={onOutsideClick}
        onResourceClick={onObjectClick}
      />
    );
  }
};
